import React, { FC, useEffect } from 'react';
import { PageWrapper, Section } from 'components/Pages/Settings/PageSettingsCommon.css';
import { PageHeading } from 'components/PageHeading/PageHeading.css';
import translate from 'utils/fnTranslate';
import { useApp } from 'providers/useApp/AppContext';
import { HelmetWrapper } from 'components/HelmetWrapper/HelmetWrapper';
import { getHelmetData, ROBOTS_INDEX } from 'utils/fnHelmet';

const PageAccessibilityNotice: FC = () => {
    const { setPageTitle } = useApp();

    useEffect(() => {
        setPageTitle(translate('SETTINGS_ACCESSIBILITY_NOTICE_LINK'));
    }, []);

    // Public, legally required statement
    return (
        <HelmetWrapper {...getHelmetData(translate('SETTINGS_ACCESSIBILITY_NOTICE_LINK'), '', ROBOTS_INDEX)}>
            <PageWrapper>
                <Section aria-label={translate('SETTINGS_ACCESSIBILITY_NOTICE_LINK')}>
                    <PageHeading looksLike="subtitle">{translate('SETTINGS_ACCESSIBILITY_NOTICE_LINK')}</PageHeading>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: translate('SETTINGS_ACCESSIBILITY_NOTICE_TEXT').replace(/\\n/gi, '<br />').replace(/\\"/gi, '"'),
                        }}
                        style={{ lineHeight: 'initial' }}
                        // aria-label={translate('SETTINGS_ACCESSIBILITY_NOTICE_TEXT').replace(/\\n/gi, ' ')}
                    />
                </Section>
            </PageWrapper>
        </HelmetWrapper>
    );
};

export default PageAccessibilityNotice;
